
/* injects from baggage-loader */
require('./style.scss');

import React, { useMemo, useState } from "react";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import Config from '../../../config/main';

const TermsAndConditions = ({ lang }) => {
    const [selected, setSelected] = useState(0);
    const [selectedSub, setSelectedSub] = useState(0);

    const subTabs = useMemo(() => {
        const selectedSection = Config.termsAndConditions?.[selected];

        if (selectedSection?.hasSubTabs) return selectedSection.subTabs;
        return null;
    }, [selected]);;

    const getDefaultLang = (obj) => obj?.[lang] || obj?.[Config.main.termsAndConditionsDefaultLanguage];

    if (!Config.termsAndConditions) return <div className="ticket-results-view-p">
        <div className="rules-wrapper-b">Not</div>
    </div>;

    return (
        <div className="ticket-results-view-p">
            <div className="rules-wrapper-b">
                <div className="rules-l-b">
                    {Config.termsAndConditions.map((item, index) =>
                        <span onClick={() => setSelected(index)} className={`h-r-tab ${index === selected ? 'activ' : ''}`} key={item}>
                            <span>{getDefaultLang(item.title)}</span>
                        </span>
                    )}
                </div>
                <div className="rules-r-b">
                    <div className="help-tabs-bar">
                        {subTabs?.map((item, index) => <span
                            className={`h-r-tab ${index === selectedSub ? 'activ' : ''}`}
                            key={getDefaultLang(item.title)}
                            onClick={() => setSelectedSub(index)}
                        >
                            {getDefaultLang(item.title)}
                        </span>)}
                    </div>
                    <div className="point-selected-i">
                        <p dangerouslySetInnerHTML={{
                            __html: getDefaultLang(subTabs ? subTabs[selectedSub].textSubTranslationKey : Config.termsAndConditions[selected].textTranslationKey)
                        }} />
                    </div>
                </div>
            </div>
        </div>);
};

TermsAndConditions.propTypes = {
    lang: PropTypes.string.isRequired
};

const mapStateToProps = state => ({
    lang: state.preferences.lang
});

export default connect(mapStateToProps)(TermsAndConditions);